import { BUILD_ID } from '@/generated/buildInfo'

const isEnvFlagEnabled = value => String(value ?? 'true').toLowerCase() !== 'false'

const isTheFlowEnabled = isEnvFlagEnabled(process.env.VUE_APP_ENABLE_THE_FLOW)

export { isTheFlowEnabled }
export default isTheFlowEnabled
